import { scaleSequential, max, min } from "d3";
import * as d3Chromatic from "d3-scale-chromatic";

export const getColorInterpolator = (name) => {
  const interpolators = {
    BuGn: d3Chromatic.interpolateBuGn,
    OrRd: d3Chromatic.interpolateOrRd,
    PuBu: d3Chromatic.interpolatePuBu,
    YlGnBu: d3Chromatic.interpolateYlGnBu,
    Blues: d3Chromatic.interpolateBlues,
    Oranges: d3Chromatic.interpolateOranges,
    Greens: d3Chromatic.interpolateGreens,
    Purples: d3Chromatic.interpolatePurples,
    Reds: d3Chromatic.interpolateReds,
    Greys: d3Chromatic.interpolateGreys,
    Grays: d3Chromatic.interpolateGreys,
    GnBu: d3Chromatic.interpolateGnBu,
    RdBu: d3Chromatic.interpolateRdBu,
    RdGy: d3Chromatic.interpolateRdGy,
    PiYG: d3Chromatic.interpolatePiYG,
    PuOr: d3Chromatic.interpolatePuOr,
    RdYlBu: d3Chromatic.interpolateRdYlBu,
  };
  if (!interpolators.hasOwnProperty(name)) {
    const err = `Unrecognized color: ${name}`;
    throw err;
  }
  return interpolators[name];
};

export const setColorScale = (
  data,
  colors = "YlGnBu",
  dmin = undefined,
  dmax = undefined,
  reverse = false
) => {
  const dMax = dmax === undefined ? max(data) : dmax;
  const dMin = dmin === undefined ? min(data) : dmin;
  const scale = scaleSequential(getColorInterpolator(colors));
  if (reverse) {
    scale.domain([dMax, dMin]);
  } else {
    scale.domain([dMin, dMax]);
  }
  return scale;
};
